import { useState } from 'react';
import { SocialButton } from '@fpsm/cxy-components/SocialButton';
import { Form } from '@remix-run/react';

import { type Repub, REPUBS } from '@cx-modules/constants';

import { type View, VIEW_SIGNUP } from '~/providers/auth-modal-provider';
import { useMyOCContext } from '~/providers/myoc-context';
import { type OAuth2Provider, providers } from '~/templates/auth/types';
import { trackEvent } from '~/utils/dataLayer';

import { actions, events, views } from '../../types';

import styles from './styles/SocialButtons.module.css';

export const SocialButtons = ({
  currentUrl,
  repub,
  view




}: {currentUrl: string;repub: Repub;view: View;}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { myocConfig } = useMyOCContext();
  const { showFacebookLogin, showGoogleLogin } = myocConfig;

  const renderFormWithSocialButton = (provider: OAuth2Provider) => {
    if (provider === providers.FACEBOOK && !showFacebookLogin) return null;
    if (provider === providers.GOOGLE && !showGoogleLogin) return null;

    const prefix = repub !== REPUBS.OC.name ? `/${repub.toLowerCase()}` : '';
    const action = `${prefix}/plus/auth/${provider}`;

    const inputView = view === VIEW_SIGNUP ? views.SIGN_UP : views.LOGIN;

    return (
      <Form
        action={action}
        method="post"
        onSubmit={() => {
          setIsLoading(true);
          trackEvent(events.SOCIAL_ATTEMPT, {
            eventAction: actions.SOCIAL_AUTH,
            method: provider,
            view: inputView
          });
        }}>

				<input
          key="returnTo"
          name="returnTo"
          type="hidden"
          value={currentUrl} />

				<input key="view" name="view" type="hidden" value={inputView} />
				<SocialButton
          className={styles.socialButton}
          isLoading={isLoading}
          variant={provider} />

			</Form>);

  };

  return (
    <>
			{renderFormWithSocialButton(providers.FACEBOOK)}
			{renderFormWithSocialButton(providers.GOOGLE)}
		</>);

};

SocialButtons.displayName = 'SocialButtons';